<template>
  <div class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Manage Subscriptions</p>
      <BaseRoundedButton @click="handleCreateSideBar">
        <p class="font-sans">Create New</p>
      </BaseRoundedButton>
    </div>
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-md">
            <th class="py-2 font-normal">Subscription Name</th>
            <th class="py-2 font-normal">Price</th>
            <th class="py-2 font-normal text-center">Description</th>
            <th class="py-2 font-normal text-center">Type</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="subscription in subscriptions"
            :key="subscription.id"
            class="text-lg"
          >
            <td class="py-3">{{ subscription.name }}</td>
            <td>$ {{ parseFloat(subscription.price).toFixed(2) }}</td>
            <td>{{ subscription.description }}</td>
            <td>
              <div class="flex justify-center">
                <div class="flex justify-center">
                  <div
                    v-if="subscription.type == '1'"
                    class="
                      px-4
                      py-1
                      bg-light-blue
                      text-blue
                      rounded-full
                      w-max
                      select-none
                    "
                  >
                    <p>Annual</p>
                  </div>
                  <div
                    v-if="subscription.type == '2'"
                    class="
                      px-4
                      py-1
                      bg-light-blue
                      text-blue
                      rounded-full
                      w-max
                      select-none
                    "
                  >
                    <p>Lifetime</p>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton
                    ><EllipsisVerticalIcon
                      class="w-8 h-8 text-black hover:text-blue cursor-pointer"
                  /></MenuButton>
                  <MenuItems
                    class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-8
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-12/12
                    "
                  >
                    <MenuItem
                      @click="handleEdit(subscription)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <PencilIcon class="text-blue w-5 h-5 mr-4" />
                        <p class="text-blue">Edit</p>
                      </div>
                    </MenuItem>
                    <MenuItem
                      @click="handleDelete(subscription.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <TrashIcon class="text-red w-5 h-5 mr-4" />
                        <p class="text-red">Delete</p>
                      </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- create side bar -->
  <SideBar v-show="showCreateSideBar" @close-modal="handleCreateSideBar">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <h1 v-if="!updateFlag" class="text-blue text-2xl">
        Create New Subscription
      </h1>
      <h1 v-else class="text-blue text-2xl">Update Subscription</h1>
      <div class="flex flex-col space-y-2 my-8">
        <base-text-input
          v-model="name"
          name="name"
          isAutoComplete="off"
          label="Name"
        />
        <base-text-input
          v-model="price"
          name="price"
          isAutoComplete="off"
          label="Price"
        />
        <base-text-input
          v-model="description"
          name="description"
          isAutoComplete="off"
          label="Description"
        />
      </div>
      <div class="relative">
        <listbox v-model="type">
          <ListboxButton class="w-full">
            <div>
              <p class="text-left text-gray mb-2">Type</p>
              <div
                class="
                  flex
                  items-center
                  justify-between
                  w-full
                  px-2
                  py-3
                  rounded-xl
                  border border-dark-gray
                "
              >
                <p v-if="!type" class="text-left text-gray">Select type</p>
                <p v-else class="text-blue">{{ type.name }}</p>
                <ChevronDownIcon class="w-4 h-4 text-gray" />
              </div>
            </div>
          </ListboxButton>
          <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-out"
            leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
          >
            <ListboxOptions
              class="
                absolute
                py-2
                w-full
                bg-white
                rounded-lg
                shadow-md
                border border-light-gray
              "
            >
              <ListboxOption
                v-for="option in typesList"
                :key="option.id"
                :value="option"
                class="hover:bg-light-gray px-4 py-2 font-sans font-md"
              >
                {{ option.name }}
              </ListboxOption>
            </ListboxOptions>
          </transition>
        </listbox>
      </div>
      <div
        class="
          flex flex-row
          items-center
          justify-between
          space-x-4
          mt-auto
          mb-4
        "
      >
        <BaseRoundedButton
          @click="handleCreateSideBar"
          class="bg-dark-gray w-2/6"
        >
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton
          v-if="!updateFlag"
          @click="handleSaveSubscription"
          class="w-4/6"
        >
          <p>Create Subscription</p>
        </BaseRoundedButton>
        <BaseRoundedButton v-else @click="handleSaveUpdate" class="w-4/6">
          <p>Update Subscription</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>

<script>
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import {
  PencilIcon,
  TrashIcon,
  EllipsisVerticalIcon,
} from "@heroicons/vue/24/outline";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Menu,
  MenuButton,
  MenuItems,
  MenuItem,
} from "@headlessui/vue";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import userService from "../Services/user.service";
import { useToast } from "vue-toastification";
export default {
  name: "ManageSubscription",
  components: {
    BaseRoundedButton,
    PencilIcon,
    TrashIcon,
    EllipsisVerticalIcon,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    SideBar,
    BaseTextInput,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      showCreateSideBar: false,
      updateFlag: false,
      name: "",
      price: "",
      type: "",
      description: "",
      tempId: "",
      typesList: [
        { id: "1", name: "Annual" },
        { id: "2", name: "Lifetime" },
      ],
      subscriptions: [],
    };
  },
  methods: {
    getSubscription() {
      userService.getSubscriptionList().then((response) => {
        this.subscriptions = response.data.data;
      });
    },
    handleCreateSideBar() {
      this.showCreateSideBar = !this.showCreateSideBar;
      this.updateFlag = false;
      if (!this.updateFlag) {
        this.name = "";
        this.price = "";
        this.type = "";
        this.description = "";
      }
    },
    handleSaveSubscription() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("price", this.price);
      formData.append("description", this.description);
      formData.append("type", this.type.id);

      userService
        .storeSubscription(formData)
        .then(() => {
          this.$Progress.finish();
          this.name = "";
          this.price = "";
          this.type = "";
          this.description = "";
          this.getSubscription();
          this.toast.success("Create new subscription successful.");
          this.showCreateSideBar = false;
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot create subscription.");
          console.log(error);
        });
    },
    handleDelete(id) {
      this.$Progress.start();
      userService
        .delSubscription(id)
        .then(() => {
          this.$Progress.finish();
          this.getSubscription();
          this.toast.success("Delete subscription successfull.");
        })
        .catch((error) => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot delete subscription");
          console.log(error);
        });
    },
    handleEdit(value) {
      this.tempId = value.id;
      this.updateFlag = true;
      this.name = value.name;
      this.price = value.price;
      this.type = value.type;
      this.description = value.description;
      this.showCreateSideBar = true;
    },
    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("price", this.price);
      formData.append("description", this.description);
      formData.append("type", this.type.id);

      userService
        .storeUpdateSubscription(this.tempId, formData)
        .then(() => {
          this.$Progress.start();
          this.$Progress.finish();
          this.name = "";
          this.price = "";
          this.type = "";
          this.description = "";
          this.tempId = "";
          this.getSubscription();
          this.toast.success("Create new subscription successful.");
          this.showCreateSideBar = false;
          this.updateFlag = false;
        })
        .catch((error) => {
          console.log(error);
          this.$Progress.fail();
          this.toast.error("Error! Cannot update subscription.");
        });
    },
  },
  created() {
    this.$Progress.start();
    this.getSubscription();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
</style>